import React, { Component } from 'react';
import { message, Form, Input, Button, Icon } from 'antd';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { apis } from '../api/index.js';
import './login.css';

import { Translation } from 'react-i18next';
import { LoginEamilIcon, LoginTimeIcon } from '../../src/utils/svg';

class LoginByEmail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sendEmailButtonDisabled: true,
      email: '',
    };
  }

  static propTypes = {
    user: PropTypes.object,
    history: PropTypes.object,
    handleLoginResult: PropTypes.func.isRequired,
    setLoginType: PropTypes.func.isRequired,
    form: PropTypes.object,
  };

  componentDidMount() {}

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) this.login(values);
    });
  };

  login = values => {
    let post = { email: values.email, vcode: values.code };

    apis.loginFromEmail(post).then(result => {
      this.props.handleLoginResult(result);
    });
  };

  handleregister = () => {
    this.props.history.push('/register');
  };

  sendVCodeToEmail = () => {
    const { email } = this.state;
    apis.sendVCodeToEmail(email).then(res => {
      if (res.code === '0') message.success('验证码发送成功');
    });
  };

  handleEmailChange = ({ target: { value } }) => {
    const emailReg = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/;
    if (emailReg.test(value)) {
      this.setState({ sendEmailButtonDisabled: false, email: value });
    }
  };

  setLoginType = type => {
    this.props.setLoginType(type);
  };
  downloadExe = () => {
    window.location.href = `https://production.jfhealthcare.cn/ai-web/upgrade/JfaiClient.zip`;
  };
  render() {
    const { getFieldDecorator } = this.props.form;

    const inputStyle = { color: 'rgba(0,0,0,.25)', fontSize: '18px' };

    return (
      <Translation>
        {t => (
          <div className="login-form-box">
            <p className="form-tit">
              <span>邮箱快捷登录</span>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <Button
                type="link"
                className="login-by-email"
                onClick={this.setLoginType.bind(this, 'account')}
              >
                帐号密码登录&gt;
              </Button>
            </p>
            <Form onSubmit={this.handleSubmit} className="login-form">
              <Form.Item>
                {getFieldDecorator('email', {
                  rules: [{ required: true, message: t('emailTip') }],
                })(
                  <div className="loginIconBox">
                    <span className="loginIcon">
                      <LoginEamilIcon />
                    </span>
                    <Input
                      placeholder={t('email')}
                      style={inputStyle}
                      className="login-input"
                      onChange={this.handleEmailChange}
                    />
                  </div>
                )}
              </Form.Item>
              <Form.Item style={{ display: 'inline-block' }}>
                {getFieldDecorator('code', {
                  rules: [{ required: true, message: t('verifyCodeTip') }],
                })(
                  <div className="loginIconBox" style={{ width: '200px' }}>
                    <span className="loginIcon">
                      <LoginTimeIcon />
                    </span>
                    <Input
                      placeholder={t('verifyCode')}
                      style={inputStyle}
                      className="login-input"
                    />
                  </div>
                )}
              </Form.Item>
              <Button
                className="img-button email-send-button"
                type="primary"
                disabled={this.state.sendEmailButtonDisabled}
                onClick={this.sendVCodeToEmail}
              >
                发送验证码
              </Button>
              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  className="login-form-button"
                  size="large"
                  block
                >
                  {t('login')}
                </Button>
                <p className="to-register from-login">
                  没有账号？
                  <Button type="link" onClick={this.handleregister}>
                    点击注册
                  </Button>
                  <Button
                    type="link"
                    className="download-exe"
                    onClick={this.downloadExe}
                  >
                    <Icon
                      type="vertical-align-bottom"
                      style={{
                        fontSize: '16px',
                        position: 'relative',
                        right: '-8px',
                        top: '1px',
                        color: '#0f80ff',
                      }}
                    />
                    下载客户端
                  </Button>
                </p>
              </Form.Item>
            </Form>
          </div>
        )}
      </Translation>
    );
  }
}

export default withRouter(Form.create()(LoginByEmail));
